import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PolicyDetails } from './../view-models/policy-details.model';
import { FeatureService, TripDetails } from './../../shared';
import { PolicyViewConfig, TypeaheadHelper } from '@bhtp-client-web/component';
import { State } from '@bhtp-client-api/eligibility';
import { EditSectionComponent } from './../edit-section.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'edit-trip-details',
    template: require('./edit-trip-details.component.html')
})
export class EditTripDetailsComponent extends EditSectionComponent<TripDetails> {
    @Input() public tripDetails: PolicyDetails;
    @Input() public policyConfig: PolicyViewConfig;
    @Input() public states: State[] = [];

    public blockedProvidersBaseUrl: string;
    private tripDetailsForm: FormGroup = new FormGroup({});

    constructor(private features: FeatureService) {
        super();

        this.blockedProvidersBaseUrl = this.features.getConsumerDomain();

        this.tripDetailsForm.valueChanges.debounceTime(500).subscribe((changes) => {
            let updatedModel: TripDetails = new TripDetails();
            this.toTripDetails(changes, updatedModel);
            this.valueChanges.emit(updatedModel);
        });
    }

    public canContinue(isQuickQuote: boolean = false): Observable<boolean> {
        return Observable.of(this.tripDetailsForm.valid);
    }

    public writeValues(target: TripDetails): void {
        let source: any = this.tripDetailsForm.getRawValue();

        this.toTripDetails(source, target);
    }

    private toTripDetails(source: any, target: TripDetails): void {
        // Trip Dates
        if (source.tripDates) {
            target.departureDate = source.tripDates.departureDate;
            target.returnDate = source.tripDates.returnDate;
        }

        // Trip Destination
        if (source.tripDestination) {
            target.destination = TypeaheadHelper.extractTypeaheadValue(source.tripDestination.destination);
            target.destinationCity = source.tripDestination.destinationCity;

            if (source.tripDestination.destination && source.tripDestination.destination.isoCode2) {
                target.destinationCountry = source.tripDestination.destination.isoCode2;
            }

            if (source.tripDestination.destinationState) {
                target.destinationState = source.tripDestination.destinationState;
            }
        }

        // Trip Suppliers
        let ts: any = source.tripSuppliers;
        if (ts) {
            target.airline = TypeaheadHelper.extractTypeaheadValue(ts.airline.airline);
            target.cruise = TypeaheadHelper.extractTypeaheadValue(ts.cruiseLine);
            target.hotel = TypeaheadHelper.extractTypeaheadValue(ts.hotel);
            target.rentalCompany = TypeaheadHelper.extractTypeaheadValue(ts.rentalCompany);
            target.tourOperator = TypeaheadHelper.extractTypeaheadValue(ts.tourOperator);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/trip-details/edit-trip-details.component.ts